interface StateType {
    mainBackground: string;
    bottomBackground: string;
    middleBackground: string;
    tab1: string;
    tab2: string;
}
type stateKey = keyof StateType;

interface PayloadType {
    key: stateKey;
    value: string;
}

export default {
    state: {
        tab1: '',
        tab2: '',
        mainBackground: '',
        bottomBackground: '',
        middleBackground: ''
    },
    mutations: {
        setBackgrondValue(state: StateType, playLoad: PayloadType) {
            const { key, value } = playLoad;
            if (state[key]) return;
            // console.log('key, value', key, value);
            state[key] = value;
        }
    },

    namespaced: true
};
